import React from 'react'
import '../../Styles/Study_with_us.css'
import { Grid, Card, Divider, Typography, Box } from '@mui/material'
import NoticeCarosel from '../../Component/Carosel/Notice_Carosel'
import Study_with_us_Htext from '../../Assets/Images/Study_with_us_Htext.png'

const Study_with_us = () => {
  const Study_with = {
    SU: {
      title: 'Study With Us',
      description:
        'Dr.B.R. Ambedkar Law College in Hyderabad is a renowned institution that has been empowering students with legal education for decades. With a focus on social justice and equality, the college has produced numerous accomplished legal professionals who have  made a signiﬁcant impact on society. This presentation will delve into the rich history and contributions of Dr.B.R. Ambedkar Law College.Dr.B.R. Ambedkar Law College, an integral part of Dr.B.R. Ambedkar Educational Institutions was established in the year 1991, by late G. Venkataswamy Garu, the then Member of Parliament and Deputy Floor leader during 2000-2001. He was also a visionary for a progressive society. It is a moment of pride for our college for having completed glorious 32 years of establishment. Imparting legal education was the most cherished dream of our founder Chairman Late.Sri G. Venkat Swamy Garu.Since its establishment in 1991,Dr. B. R. Ambedkar Law College has been successful in producing legal luminaries, bureaucrats & judges.',
    },
  }

  return (
    <Box
      sx={{ padding: { xs: '16px', sm: '32px' }, backgroundColor: '#f9f9f9' }}
    >
      {/* Responsive Grid Container */}
      <Grid container spacing={4}>
        {/* Left Section: Image and Description */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              padding: { xs: '8px', md: '16px' },
            }}
          >
            <img
              src={Study_with_us_Htext}
              alt="Study with us"
              style={{
                width: '100%',
                maxWidth: '400px',
                height: 'auto',
                marginBottom: '16px',
              }}
              loading="lazy"
              placeholder="blur"
            />
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: '14px', sm: '16px' },
                lineHeight: '1.6',
                textAlign: { xs: 'center', md: 'justify' },
              }}
            >
              {Study_with.SU.description}
            </Typography>
          </Box>
        </Grid>

        {/* Right Section: Notice Carousel */}
        <Grid
          item
          xs={12}
          md={6}
          style={{ alignItems: 'center' }}
          className="noticeBoard"
        >
          <Card
            className="mb-3"
            style={{
              backgroundImage: 'linear-gradient(180deg, #F15215, #494798)',
              borderRadius: '10px',
            }}
          >
            <NoticeCarosel />
          </Card>
        </Grid>
      </Grid>

      {/* Divider */}
      <Divider
        flexItem
        sx={{
          backgroundImage: 'linear-gradient(#F15215, #494798)',
          height: { xs: '3px', md: '5px' },
          borderRadius: '10px',
          marginTop: { xs: '16px', md: '24px' },
        }}
      />
    </Box>
  )
}

export default Study_with_us
